// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Text_wrapper__1VguF","stroke":"Text_stroke__3nQrC"};